import { MdClose, MdAdd } from "react-icons/md";
import { CircularProgress } from "@mui/material";
import tw from "tailwind-styled-components";
import { ModalHeader, ScrollableContent } from "../Styles/InputStyles";
import axios from "axios";
import { useQuery } from "react-query";
import Config from "../../Config";
import { useSelector } from "react-redux";
import moment from "moment";
import { useState } from "react";
import AddNoteModal from "./AddNoteModal";
import NotFoundModel from "../NotFoundModel";

const Notes = ({ selectedData, setIsViewNotes, isViewNotes }) => {
    const tenantId = selectedData?.tenantId || selectedData?.id;
    const user = useSelector((state) => state.UserReducer.user);
    const [isAddNoteModalOpen, setIsAddNoteModalOpen] = useState(false);

    const fetchListing = async () =>
        await axios.get(`${Config.apiUrl}/tenant/notes/list?tenantId=${tenantId}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${user.token}`,
            },
        });

    const { isLoading, error, data, refetch, isRefetching } = useQuery(
        ['notesData', tenantId],
        fetchListing,
        {
            enabled: Boolean(isViewNotes && tenantId),
        }
    );

    const isEmptyNotes = data?.data?.data?.length === 0;

    const handleNoteAdded = () => {
        refetch();
    };

    return (
        <>
            <Container>
                <ModalHeader>
                    <h1 className="text-white text-lg font-medium">Notes</h1>
                    <button onClick={() => setIsViewNotes(false)}>
                        <MdClose color="white" size={24} />
                    </button>
                </ModalHeader>

                {(isLoading || isRefetching) && (
                    <div className="flex justify-center items-center my-40">
                        <CircularProgress size={40} />
                    </div>
                )}

                {!isLoading && !isRefetching && (
                    <Content>
                        {isEmptyNotes ? (
                            <div className="flex items-center justify-center h-full min-h-[60vh]">
                            <NotFoundModel msg="No notes yet"/>
                            </div>
                        ) : (
                            // Notes Timeline
                            <ScrollableContent className="max-h-[calc(100vh-100px)]">
                                <TimelineWrapper>
                                    {data?.data?.data?.map((log, index) => (
                                        <TimelineRow key={index}>
                                            <TimelineLeft>
                                                <TimelineDot />
                                                <TimelineLine />
                                                {/* {index !== data?.data?.data?.length - 1 && <TimelineLine />} */}
                                            </TimelineLeft>
                                            <TimelineContent>
                                                <DateText>
                                                    {moment(log.createdAt).format("DD MMM YYYY, hh:mm A")}
                                                </DateText>
                                                <ActivityText>{log.note}</ActivityText>
                                                <DescriptionText>
                                                    By {log.addedByName || "--"}
                                                </DescriptionText>
                                            </TimelineContent>
                                        </TimelineRow>
                                    ))}
                                </TimelineWrapper>
                            </ScrollableContent>
                        )}
                    </Content>
                )}

                {/* Floating Action Button - Always visible when not loading */}
                {!isLoading && !isRefetching && (
                    <FabButton
                        onClick={() => setIsAddNoteModalOpen(true)}
                        aria-label="Add note"
                    >
                        <MdAdd size={24} />
                    </FabButton>
                )}
            </Container>

            {/* Add Note Modal */}
            <AddNoteModal
                isOpen={isAddNoteModalOpen}
                onClose={() => setIsAddNoteModalOpen(false)}
                tenantId={tenantId}
                onNoteAdded={handleNoteAdded}
                setIsAddNoteModalOpen={setIsAddNoteModalOpen}
            />
        </>
    );
};

// Styled Components
const Container = tw.div`bg-white w-full overflow-hidden flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const Content = tw.div`flex-1 p-4`;
const EmptyState = tw.div`text-center h-full flex items-center justify-center`;
const TimelineWrapper = tw.div`relative space-y-6`;
const TimelineRow = tw.div`flex gap-4 relative`;
const TimelineLeft = tw.div`flex flex-col items-center relative min-w-[20px]`;
const TimelineDot = tw.div`w-3 h-3 bg-blue-500 rounded-full`;
const TimelineLine = tw.div`w-0.5 bg-gray-300 flex-1`;
const TimelineContent = tw.div`flex flex-col gap-0.5 pb-4 border-b border-gray-100 w-full`;
const ActivityText = tw.p`text-sm font-medium text-gray-700`;
const DescriptionText = tw.p`text-xs text-gray-400`;
const FabButton = tw.button`fixed bottom-6 right-6 w-14 h-14 text-white rounded-full flex items-center justify-center shadow-md bg-gradient-to-r from-primary-color to-teal-400 `;
// const FabButton = tw.button`fixed bottom-6 right-6 w-14 h-14 bg-primary-color hover:bg-primary-color/80 text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-200 z-50`;
const DateText = tw.p`text-xs text-gray-400`;
export default Notes;